import { createPlugin } from 'leva/plugin'
import { PresetsPanel } from './PresetsPanel'
import { normalize, sanitize } from '../utilities/config'

export const presets = createPlugin({
  normalize,
  sanitize,
  component: PresetsPanel,
})